import { FC, useEffect } from 'react';

import { motion } from 'motion/react';

import { ECompanyStep, usePersonalStore } from '@/entities/user';

import { KybStepStatus } from '@/shared/api';
import { ROUTES, useNavigate } from '@/shared/lib';

import RootLayoutContent from '../RootLayoutContent';

export const RootLayout: FC = () => {
  const navigate = useNavigate();
  const user = usePersonalStore((state) => state.user);
  const company = usePersonalStore((state) => state.company);

  useEffect(() => {
    if (
      localStorage.getItem('@accessToken') &&
      user?.isRegistered &&
      company?.step === ECompanyStep.CompanyOnboardingCompleted
    ) {
      if (company?.status === KybStepStatus.Successful) {
        return;
      }
      void navigate(ROUTES.KYB_RESULT, { replace: true });
      return;
    }

    if (user && !user.isRegistered) {
      void navigate(ROUTES.REGISTRATION, { replace: true });
      return;
    }
    if (
      !company?.step ||
      company.step !== ECompanyStep.CompanyOnboardingCompleted
    ) {
      void navigate(ROUTES.KYB_QUESTIONNAIRE, { replace: true });
      return;
    }
    void navigate(ROUTES.WELCOME, { replace: true });
  }, [navigate, user, company]);

  if (!user?.isRegistered) return null;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <RootLayoutContent />
    </motion.div>
  );
};
